import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { ClientDetailForm } from 'Components/ComponentLibrary/Organisms/ClientDetailForm/ClientDetailForm';
import {
  FDDialogContent,
  FDPrimaryActionButton,
} from '@facet-wealth/design';
import { DialogActions, DialogTitle } from 'Views/Page/Content/Modal/Components';
import { dataAttrs } from 'Helpers/Testing';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

export const ClientLayout = () => {
  const { resource, onSubmit } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  const handleSubmit = async () => {
    const resp = await onSubmit();

    if (resp) {
      clearModalCollection();
    }
  };

  return (
    <>
      <DialogTitle value={(resource.id() !== undefined) ? 'Edit Member' : 'Create Member'} />
      <FDDialogContent>
        <ClientDetailForm />
      </FDDialogContent>
      <DialogActions>
        <FDPrimaryActionButton
          {...dataAttrs('dialog-submit')}
          onClick={handleSubmit}
          label={'Save Changes'}
        />
      </DialogActions>
    </>
  );
};
